import React, { HTMLProps } from 'react';
import { BodyShort, HelpText, HStack, Popover } from '@navikt/ds-react';
import { store } from '@/app/_components/store/store';
import { hjelpetekstAriaLabel } from '@/utils/formatting/tekst';
import { css } from '@emotion/css';
interface AttributtInlineProps extends Pick<HTMLProps<HTMLDivElement>, 'className' | 'style'> {
  title?: string;
  data: React.ReactNode;
  hjelpetekst?: React.ReactNode;
}
const AttributtInline = (props: AttributtInlineProps) => {
  const helptextRef = React.useRef(null);
  const {
    tekst
  } = store.useReducerState();
  const [popoverVisible, setPopoverVisible] = React.useState(false);
  return <HStack gap="space-16" wrap={false}>
            <HStack className={css({
      flexShrink: 0
    })}>
                <HStack gap="space-8" ref={helptextRef} minWidth={'7rem'}>
                    <BodyShort weight="semibold">{props.title}</BodyShort>
                    {props.hjelpetekst && <HelpText title={hjelpetekstAriaLabel(tekst, props.title)}>{props.hjelpetekst}</HelpText>}
                    <Popover anchorEl={helptextRef.current} open={popoverVisible} onClose={() => {
          setPopoverVisible(false);
        }} placement="bottom-start">
                        <div className={css({
            padding: 6
          })}>{tekst.info.opplysningIkkeValgt}</div>
                    </Popover>
                </HStack>
            </HStack>

            {/* min-width: 0 lar verdien brytes over flere linjer i stedet for å dyttes ned under etiketten. */}
            <div className={css({
      minWidth: 0,
      overflowWrap: 'break-word'
    })}>{props.data}</div>
        </HStack>;
};
export default AttributtInline;